﻿import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { APILoginService } from '../../_services/login/API-login';
import { APIEntityService } from '../../_services/entity/API-entity';
import { LoginComponent } from '../login/login.component';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import * as crypto from 'crypto-js';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { APIConstants } from '../../../../_config/restapis';
import { formatDate, CommonModule } from '@angular/common';
import { MustMatch } from '../../../../_helpers/must-match-validator';
// import { FileSelectDirective, FileUploader } from 'ng2-file-upload';
import * as CryptoJS from 'crypto-js';

import { Location } from '@angular/common';

export interface communicationtypelist {
  value: string;
  viewValue: string;
}

export interface categorylist {
  value: string;
  viewValue: string;
}

export interface novariablelistlist {
  value: string;
  viewValue: string;
}

export interface languagelist {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-content-template-registration-action',
  templateUrl: './content-template-registration-action.component.html',
  styleUrls: ['./content-template-registration-action.component.css']
})
export class ContentTemplateRegistrationActionComponent implements OnInit {
  email: any;
  mobileno: any;
  showOTPfields: boolean;
  public entityId: any;
  makeRead: boolean;
  warningForNotMatchingEnitity: boolean;
  headerslist: any;
  selectedarray: any;
  urn: any;
  disableForm: boolean = false;
  filename: any;
  public submitted: boolean = false;
  public regsubmitted: boolean = false;
  Approver_EmailID: any;
  Approver_EntityID: any;
csTempID: any
  csTempName: any;
  csTempContent: any
ApprovedOrRejected: boolean = false;
     
 //Added for apk,callnumber, url,OTT url
 isapkdocs: boolean = false;
 apkfile: any

UrnFromURL: any;  
  constructor(private fb: FormBuilder,
    private es: APILoginService,
    private ls: APIEntityService,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private _route: ActivatedRoute,
    private router: Router,
    private _location: Location,
    ) {
      this._route.params.subscribe((params) => {
        this.UrnFromURL = params['urn'];
      })
  }


  response: any;
  entitymodifyForm: FormGroup;
  selectedValue: String;
  telelist: any;
  industrylist: any;
  sectorlist: any;
  public govtlistdiv: boolean = false;


  get f() { return this.entitymodifyForm.controls; }





  attachmentList: any = [];
  text_variables: any = [];
  date_variables: any = [];
  number_variables: any = [];
  con_num_variables: any = [];
  com_url_variables: any = [];
  url_domain_variables: any = [];
  apk_variables: any = [];
  date_time_variables: any = [];
  currency_variables: any = [];
  variableDetails: any = []



  languagelistitems: languagelist[] = [
    { value: 'English', viewValue: 'English' },
    { value: 'Hindi', viewValue: 'Hindi' },
  ];


  communicationtypelistitems: communicationtypelist[] = [
    { value: 'P', viewValue: 'Promotional' },
    { value: 'T', viewValue: 'Transactional' },
    { value: 'SE', viewValue: 'Service Explicit' },
    { value: 'SI', viewValue: 'Service Implicit' }

  ];

  categorylistitems: categorylist[] = [
    { value: '1', viewValue: 'Banking / Insurance / Financial Products / Credit cards' },
    { value: '2', viewValue: 'Real Estate' },
    { value: '3', viewValue: 'Education' },
    { value: '4', viewValue: 'Health' },
    { value: '5', viewValue: 'Consumer Goods and automobiles' },
    { value: '6', viewValue: 'Communication / Broadcasting / Entertainment / IT' },  
    { value: '7', viewValue: 'Tourism / Leisure' },  
    { value: '8', viewValue: 'Food and Beverages' },         

  ];

  novariablelistlistitems: novariablelistlist[] = [
    { value: '0', viewValue: '0' },
    { value: '1', viewValue: '1' },
    { value: '2', viewValue: '2' },
    { value: '3', viewValue: '3' },
    { value: '4', viewValue: '4' },
    { value: '5', viewValue: '5' },
    { value: '6', viewValue: '6' },
    { value: '7', viewValue: '7' },
    { value: '8', viewValue: '8' },
    { value: '9', viewValue: '9' },
    { value: '10', viewValue: '10' },
    { value: '11', viewValue: '11' },
    { value: '12', viewValue: '12' },
    { value: '13', viewValue: '13' },
    { value: '14', viewValue: '14' },
    { value: '15', viewValue: '15' },
    { value: '16', viewValue: '16' },
    { value: '17', viewValue: '17' },
    { value: '18', viewValue: '18' },
    { value: '19', viewValue: '19' },
    { value: '20', viewValue: '20' }

  ];


  ngOnInit() {

    this.entitymodifyForm = this.fb.group({
      Entity_ID: ['',],
      industry_type: ['',],
      Organization: ['',],
      //   industry_category: ['',],
      communication_type: ['',],
      category: ['',],
      language: ['',],
      header_list: ['',],
      content_type: ['',],
      template_name: ['',],
      no_variables: ['',],
      template_content: ['',],
      docname: [''],
      desc_template: ['',],
      var_justification: ['',],
      csTempID: ['',],
      csTempName: ['',],
      csTempContent: ['',],
      restr_comments: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(250)]],
      //Added for apk,callnumber, url,OTT url
      apkfile: [''],
      URL: [''],
      OTTURL: [''],
      callbackno: [''],
      text_variables: [''],
      date_variables : [''],
      number_variables: [''],
      con_num_variables: [''],
      com_url_variables: [''],
      url_domain_variables: [''],
      apk_variables: [''],
      date_time_variables: [''],
      currency_variables: [''],
      variableDetails: ['']

    });
    console.log("dsdfdfds", this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_CLASS))
    if (this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_CLASS) == "PE") {
      this.ApprovedOrRejected = true;
     }
    this.getTemplateDetails();
   
    // if(this.Approver_EmailID==null || this.Approver_EmailID==undefined){
    //   this.router.navigateByUrl('/')
    // }
  }//end of oninit

  showCSTinfo() {
    
    this.$modal.promptModal({
      title: "Consent Template Name: " + this.csTempName,
      msg: "Consent Template Content: " + this.csTempContent
    });
   }
  Preview() {
    console.log("called")
    let name = this.entitymodifyForm.get("template_name").value
    let contentinfo = this.entitymodifyForm.get("template_content").value

    this.$modal.promptModal({
      title: name,
      msg: contentinfo
    });
  }
//  async onSubmit(status) {

//     if (this.entitymodifyForm.invalid) {
  
//       alert("Please enter your Comments")
//       this.disableForm = true;
//       let invalid = [];
//       let controls = this.entitymodifyForm.controls;
//       this.regsubmitted = true;
//       for (const name in controls) {
//         if (controls[name].invalid) {
//           invalid.push(name);
//         }
//       }
//       return;
//     }
//     else {
//       this.regsubmitted = false;

//       console.log("submitting form..", status);
// console.log("Response is",this.response)
// let response=this.response
// let tempObj={}
// console.log("this.response.Template_Category is",this.response.Template_Category)

//       this.categorylistitems.forEach(function (Obj) {
//         if (Obj.viewValue == response.Template_Category) {
//           tempObj["Template_Category"] = Obj["value"];
//         }
//       })

  

//       this.communicationtypelistitems.forEach(function (Obj) {
//         if (Obj.viewValue == response.Template_CommunicationType) {
//           tempObj["Template_CommunicationType"] = Obj["value"];
//         }
//       })
    
//         if (this.entitymodifyForm.get("content_type").value  =="Text") {
//           tempObj["ctype"]="T"
//         }
//         else if (this.entitymodifyForm.get("content_type").value  =="Unicode") {
//           tempObj["ctype"]="U"

//         }
//         else {
//           tempObj["ctype"]=""

//         }
//         this.Approver_EntityID = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
     
//       this.entitymodifyForm.value["Template_CommunicationType"] = tempObj["Template_CommunicationType"]


//       this.entitymodifyForm.value["Template_Category"] = tempObj["Template_Category"]
      
//       this.entitymodifyForm.value["ctype"] = tempObj["ctype"]
//       this.entitymodifyForm.value["T_Assigned_Date"] = this.response.T_Assigned_Date;


     

//       this.entitymodifyForm.value["CSTempID"] = this.csTempID;

//       this.entitymodifyForm.value["Entity_ID"] = this.entityId;

//       this.entitymodifyForm.value["Template_Status"] = status;

//       this.entitymodifyForm.value["Template_Ref_No"] = this.urn;
//       this.entitymodifyForm.value["T_Approved_By"] = this.Approver_EntityID;
//       this.entitymodifyForm.value["variableDetails "] = this.variableDetails;
//       console.log("JSON body",this.entitymodifyForm.value)

//      await this.ls.updateTemplate(this.entitymodifyForm.value)
//         .subscribe(r => {
//           if (r.status == "success") {
//             if (r.message == "Template has been approved") {
//               this.$modal.successModal({
//                 title: 'Content Template Registration Action',
//                 msg: "Template has been approved"
//               });
//               this.router.navigateByUrl('/template-worklist');

//             }
//             else if (r.message == "Template has been Rejected") {
//               this.$modal.successModal({
//                 title: 'Content Template Registration Action',
//                 msg: "Template has been Rejected"
//               });
//               this.router.navigateByUrl('/template-worklist');

//             }
//             else if (r.message == "Template has been sent to modification") {
//               this.$modal.successModal({
//                 title: 'Content Template Registration Action',
//                 msg: "Template has been sent to modification"
//               });
//               this.router.navigateByUrl('/template-worklist');

//             }
//             else if (r.message == "Already Sent to Modification") {
//               this.$modal.errorModal({
//                 title: 'Content Template Registration Action',
//                 msg: "This template was already sent for modification"
//               });
//             }
//             else if (r.message == "Error Occured while inserting into DLT") {
//               this.$modal.errorModal({
//                 title: 'Content Template Registration Action',
//                 msg: "Error Occured while inserting into DLT . Reason " + r.error
//               });
//             }
//             else if (r.message == "Approved" || r.message == "Rejected") {
//               this.$modal.errorModal({
//                 title: 'Content Template Registration Action',
//                 msg: "This template was already " + r.message
//               });
//             }
//             else if (r.message == "Template name already exists") {
//               this.$modal.errorModal({
//                 title: 'Content Template Registration Action',
//                 msg: "Template name already exists "
//               });
//             }
            
//             else if (r.message == "Template already sent to modification") {
//               this.$modal.errorModal({
//                 title: 'Content Template Registration Action',
//                 msg: "Template can be sent for modification only once. You are supposed to either Approve Or Reject now"
//               });
//             }
            
//             else {
//               this.$modal.errorModal({
//                 title: 'Content Template Registration Action',
//                 msg: "Some Error Occured"
//               });
//             }
//           }
//           else {
//             this.$modal.errorModal({
//               title: 'Content Template Registration Action',
//               msg: "Some Error Occured"
//             });
//           }

//         })

//     }
//   }

  download(file1, Refno) {

    var data = {
      "Container": "templates",
      "URN": "1607" + Refno,
      "FileName": file1
    }

    this.ls.templatefiledownload(data).subscribe(r => {

      this.downloadFile(r, file1);
      this.$modal.successModal({
        title: 'Entity Summary',
        msg: 'File has been downloaded Successfully'
      });
    })

  }

  backClicked() {
    console.log("clickedddddddddddd");
    this._location.back();
  }

  private downloadFile(res: any, filename: string): void {
    const url = window.URL.createObjectURL(res);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }


  async getTemplateDetails() {
    await this._route.params.subscribe((params) => {
      this.urn = params['urn'];
    })
    console.log("URN", this.urn)
    let data = {

      "URN": this.urn
    }
    console.log("data", data)
    this.ls.getTemplateDetails(data)
      .subscribe(r => {
        if (r.status == "success") {
          this.response = r.message;
          this.entityId = r.message.Entity_ID;
          if (r.message.Hash_TMP_Doc) {
            let fullfilename = r.message.Hash_TMP_Doc.split(".")
            this.filename = fullfilename[fullfilename.length - 2]
            this.entitymodifyForm.controls['docname'].setValue(r.message.Template_docName);

          }
        
          // this.entitymodifyForm.controls['csTempID'].setValue(r.message.CSTempID);
          // this.entitymodifyForm.controls['csTempName'].setValue(r.message.CST_Name);

          // this.entitymodifyForm.controls['csTempContent'].setValue(r.message.CST_Content);
          this.csTempID = r.message.CSTempID
          this.csTempName = r.message.CST_Name
          this.csTempContent = r.message.CST_Content

          this.entitymodifyForm.controls['communication_type'].setValue(r.message.Template_CommunicationType);

          this.entitymodifyForm.controls['category'].setValue(r.message.Template_Category);
          this.entitymodifyForm.controls['language'].setValue(r.message.Template_Language);


          this.entitymodifyForm.controls['header_list'].setValue(r.message.Template_Header.toString());
          this.entitymodifyForm.controls['content_type'].setValue(r.message.Content_Type);
          this.entitymodifyForm.controls['template_name'].setValue(r.message.Template_Name);
          this.entitymodifyForm.controls['no_variables'].setValue(r.message.Template_Variables);
          this.entitymodifyForm.controls['template_content'].setValue(r.message.Template_Content);
          this.entitymodifyForm.controls['desc_template'].setValue(r.message.Template_Description);
          this.entitymodifyForm.controls['var_justification'].setValue(r.message.tmpVerficationReason);  
          this.entitymodifyForm.controls['restr_comments'].setValue(r.message.Registrar_comments);
          this.entitymodifyForm.controls['Organization'].setValue(r.message.Entity_Organization);
          this.entitymodifyForm.controls['Entity_ID'].setValue(r.message.Entity_ID);
          this.entitymodifyForm.controls['industry_type'].setValue(r.message.E_Org_Type);
           //Added for apk,callnumber, url,OTT url
           this.entitymodifyForm.controls['URL'].setValue(r.message.URL);
           this.entitymodifyForm.controls['OTTURL'].setValue(r.message.OTTURL);
           this.entitymodifyForm.controls['callbackno'].setValue(r.message.callbackno);

          //changes by avinesh start
          this.variableDetails = r.message.variableDetails
          console.log("------- r.message.variableDetails-----------", r.message.variableDetails)
          if (r.message.variableDetails) {
            let varDetails = r.message.variableDetails //JSON.parse(r.message.variableDetails);

            for (let i = 0; i < varDetails.length; i++) {
              if (varDetails[i].type == 'text') {
                this.text_variables.push(varDetails[i].varNum)
                this.entitymodifyForm.controls['text_variables'].setValue(this.text_variables);
              }

              if (varDetails[i].type == 'date') {
                this.date_variables.push(varDetails[i].varNum)
                this.entitymodifyForm.controls['date_variables'].setValue(this.date_variables);
              }
              if (varDetails[i].type == 'number') {
                this.number_variables.push(varDetails[i].varNum)
                this.entitymodifyForm.controls['number_variables'].setValue(this.number_variables);
              }
              if (varDetails[i].type == 'contactNumber') {
                this.con_num_variables.push(varDetails[i].varNum)
                this.entitymodifyForm.controls['con_num_variables'].setValue(this.con_num_variables);
              }
              if (varDetails[i].type == 'fullUrl') {
                this.com_url_variables.push(varDetails[i].varNum)
                this.entitymodifyForm.controls['com_url_variables'].setValue(this.com_url_variables);
              }
              if (varDetails[i].type == 'domainUrl') {
                this.url_domain_variables.push(varDetails[i].varNum)
                this.entitymodifyForm.controls['url_domain_variables'].setValue(this.url_domain_variables);
              }
              if (varDetails[i].type == 'apk') {
                this.apk_variables.push(varDetails[i].varNum)
                this.entitymodifyForm.controls['apk_variables'].setValue(this.apk_variables);
              }
              if (varDetails[i].type == 'dateTime') {
                this.date_time_variables.push(varDetails[i].varNum)
                this.entitymodifyForm.controls['date_time_variables'].setValue(this.date_time_variables);
              }
              if (varDetails[i].type == 'currency') {
                this.currency_variables.push(varDetails[i].varNum)
                this.entitymodifyForm.controls['currency_variables'].setValue(this.currency_variables);
              }

            }
          }
          //changes by avinesh end

           if (r.message.Hash_apkfilename) {
             this.entitymodifyForm.controls["apkfile"].setValue(
               r.message.Hash_apkfilename.substring(r.message.Hash_apkfilename.indexOf(".") + 1));
   
             this.apkfile = r.message.Hash_apkfilename
             this.isapkdocs = true
             console.log("-------------- this.apkfile------", this.apkfile)
   
           }
        }
        else if (r.status == "fail" && r.message == "Not found") {
          this.$modal.errorModal({
            title: 'Content Template Registration Action',
            msg: "Data not found"
          });
        }
        else {
          this.$modal.errorModal({
            title: 'Content Template Registration Action',
            msg: "Error Occured while retrieving Template Details"
          });

        }


      })


  }


}//end of export